import Grid from "@mui/material/Grid";
import React, {useEffect, useState} from 'react';
import {FormControl, FormControlLabel, RadioGroup, Stack} from '@mui/material';
import TextField from "../../../../components/fields/textfield/TextField";
import {TextFieldWithMoreIcon} from "../../../../components/TextFieldWithAdornmentIcon";
import {t} from "../../../../store/localization/TranslMessasge";
import {CommonTranslationKey} from "../CommonTranslationKey";
import {DashboardTranslationKey} from "./DashboardTranslationKey";
import DiagramsPickDialog from "../diagrams/DiagramsPickDialog";
import {SaveButton} from "../../../../components/button/SaveButton";
import Radio from '@mui/material/Radio';
import diagramsApi from "../../../../common/apis/DiagramsApi";
import {useDispatch, useSelector} from "react-redux";
import {IApplicationState} from "../../../../store/Store";
import {DiagramDto} from "../../../../common/apis/diagram/DiagramDto";
import {getSaveDashboardAction} from "../../../../store/dashboard/DashboardReducer";
import {Dispatch} from "redux";
import dashboardService, {WidgetType, WidgetUpdateDto} from "../../../../common/apis/DashboardService";
import {DiagramInfoDto} from "../../../../common/apis/diagram/DiagramInfoDto";
import Snackbar from "../snackbar/Snackbar";
import Page from "../../../../components/page/Page";
import PageHeader from "../../../../components/page/PageHeader";
import PageTitle from "../../../../components/page/PageTitle";
import PageContent from "../../../../components/page/PageContent";


export default function DashboardAdministrationPage() {

    const mainWidget = useSelector((state: IApplicationState) => state.dashboard.mainWidget);
    const [value, setValue] = React.useState("emptyPage");
    const [diagramName, setDiagramName] = useState<string>("");
    const [url, setUrl] = useState<string>("");
    const [isDiagramVisible, setIsDiagramVisible] = useState<boolean>(false);
    const [isUrlVisible, setIsUrlVisible] = useState<boolean>(false);
    const [diagramId, setDiagramId] = useState<string | null>(null);
    const [dialogIsOpen, setDialogIsOpen] = useState(false);
    const [isDialogMultiselection] = useState(false);
    const [diagramError, setDiagramError] = useState(false);
    const [urlError, setUrlError] = useState(false);
    const dispatch = useDispatch();


    function setDiagramNameById(diagramId: string) {
        diagramsApi.getDiagramById(diagramId)
            .subscribe({
            next: (response) => {
                const diagram = response.response as DiagramDto;
                const diagramName = diagram.diagramInfo.name ? diagram.diagramInfo.name : "";
                setDiagramName(diagramName);
            },
            error: () => {},
        });
    }

    useEffect(() => {
        const diagramId = mainWidget?.diagramIdentifier ? mainWidget.diagramIdentifier : "";
        const url = mainWidget?.url ? mainWidget.url : "";
        if(diagramId) {
            setDiagramNameById(diagramId)
            setValue("diagram")
            setIsDiagramVisible(true);
        }
        else if (url) {
            setUrl(url);
            setValue("url");
            setIsUrlVisible(true);
        }
        else {
            setValue("emptyPage")
        }
        }, [mainWidget?.diagramIdentifier, mainWidget?.url]);

    function setInputVisibility(value: string) {
        switch (value) {
            case "diagram": {
                setIsDiagramVisible(true);
                setIsUrlVisible(false)
                setUrl("");
                setUrlError(false)
                break;
            }
            case "url": {
                setIsDiagramVisible(false);
                setIsUrlVisible(true);
                setDiagramName("");
                setDiagramError(false)
                break;
            }
            default: {
                setIsDiagramVisible(false);
                setIsUrlVisible(false);
                setDiagramName("");
                setUrl("");
                setDiagramError(false)
                setUrlError(false)
                break;
            }
        }
    }

    const setRadioButton = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setValue(value);
        setInputVisibility(value)
    };

    function changeState(dto: Array<DiagramInfoDto>) {
        const [diagram] = dto;
        setDiagramName(diagram.name!);
        setDiagramId(diagram.identifier);
        setDialogIsOpen(false);
        setUrlError(false);
        setDiagramError(false);
    }

    function createType() {
        if (diagramId !== null) {
            return WidgetType.DIAGRAM;
        } else if (url !== null) {
            return WidgetType.URL;
        }
        return WidgetType.EMPTY;
    }

    function showSuccessfulSave() {
        Snackbar.success(t(DashboardTranslationKey.SUCCESSFUL_SAVE));
    }

    function showNotSuccessfulSave(error: any) {
        Snackbar.error(t(DashboardTranslationKey.NOT_SUCCESSFUL_SAVE), error);
    }

    function setInputsToEmptyString(widget: WidgetUpdateDto) {
        const diagramId = widget.diagramId;
        diagramId ? setUrl("") : setDiagramName("");
    }

    async function saveChanges() {
        if (isNotError()) {
            const widget = createNewWidget();
            try {
                await dashboardService.updateWidget(widget);
                setInputsToEmptyString(widget)
                showSuccessfulSave()
                refreshDashboard(dispatch);
            } catch(error) {
                showNotSuccessfulSave(error);
            }
        }
    }

    function createNewWidget() {
        return {
            type: createType(),
            diagramId: diagramId,
            url: url,
        } as WidgetUpdateDto;
    }

    function isNotError() {
        if (isDiagramVisible && diagramName.trim().length === 0) {
            setDiagramError(true);
            setUrlError(false);
            return false;
        } else if (isUrlVisible && url.trim().length === 0) {
            setUrlError(true);
            setDiagramError(false);
            return false;
        }
        return true;
    }

    async function refreshDashboard(dispatch: Dispatch<any>) {
        const dashboard = await dashboardService.getDashboard();
        dispatch(getSaveDashboardAction(dashboard));
    }

    function setInputChanges(value: string) {
        setUrl(value);
        setUrlError(false);
    }

    return (
            <>
                <Page>
                    <PageHeader>
                        <PageTitle title={t(DashboardTranslationKey.ADMINISTRATION)} />
                    </PageHeader>
                    <PageContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FormControl component="fieldset">
                                    <RadioGroup value={value} onChange={setRadioButton}>
                                        <FormControlLabel value="diagram"
                                                          control={<Radio/>}
                                                          label={t(DashboardTranslationKey.DIAGRAM)}/>
                                        <FormControlLabel value="url"
                                                          control={<Radio/>}
                                                          label={t(DashboardTranslationKey.URL)}/>
                                        <FormControlLabel value="emptyPage"
                                                          control={<Radio/>}
                                                          label={t(DashboardTranslationKey.WITHOUT_DASHBOARD)}/>
                                    </RadioGroup>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} sx={{marginTop: 2, marginLeft: 4}}>
                                {isDiagramVisible &&
                                        <TextFieldWithMoreIcon
                                                label={t(DashboardTranslationKey.DIAGRAM)}
                                                value={diagramName}
                                                tooltipTitle={t(DashboardTranslationKey.SEARCH_DIAGRAM)}
                                                onClick={() => setDialogIsOpen(true)}
                                                required={true}
                                                errorMessage={diagramError ? t(CommonTranslationKey.FILL_OUT_THIS_FIELD) : undefined}
                                        />
                                }
                                {isUrlVisible &&
                                        <TextField id="url"
                                                label={t(DashboardTranslationKey.URL)}
                                                variant="outlined"
                                                value={url}
                                                onChange={value => (setInputChanges(value))}
                                                required={true}
                                                errorMessage={urlError ? t(CommonTranslationKey.FILL_OUT_THIS_FIELD) : undefined}/>
                                }
                            </Grid>
                            <Grid item xs={12}>
                                <Stack direction={"row-reverse"}>
                                    <SaveButton onClick={() => saveChanges()}/>
                                </Stack>
                            </Grid>
                        </Grid>
                    </PageContent>
                </Page>

                {dialogIsOpen && <DiagramsPickDialog isOpened={dialogIsOpen}
                        isMultiSelection={isDialogMultiselection}
                        onDiagramsPicked={(dto) => changeState(dto)}
                        onDialogClosed={() => setDialogIsOpen(false)}
                />}
            </>
    )
}